import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { http } from "@/lib/http";
import { Eyebrow } from "@/components/shared/Primitives";

const KIND_STYLE = {
  financeiro: "border-l-[var(--teal)]",
  lembrete: "border-l-[var(--coral)]",
  carinho: "border-l-[color:rgba(224,106,85,0.55)]",
};

export const AISuggestions = () => {
  const [items, setItems] = useState(null); // null=loading, []=vazio
  useEffect(() => {
    let alive = true;
    http.get("/ai/suggestions")
      .then((r) => alive && setItems(r.data?.items || []))
      .catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, []);

  if (items === null) return null; // silencioso durante loading
  if (!items.length) return null;

  return (
    <section className="mt-8 rise rise-2" data-testid="ai-suggestions">
      <div className="flex items-center justify-between">
        <Eyebrow>a IA sugere</Eyebrow>
        <Link
          to="/assistente"
          className="text-xs font-semibold text-[var(--teal)] min-h-[44px] flex items-center gap-1"
          data-testid="ai-suggestions-open-link"
        >
          conversar <ArrowRight size={12} />
        </Link>
      </div>
      <ul className="mt-3 space-y-2">
        {items.slice(0, 3).map((s, i) => (
          <li
            key={i}
            data-testid={`ai-suggestion-${i}`}
            className={`paper p-4 border-l-4 ${KIND_STYLE[s.kind] || "border-l-[var(--coffee-muted)]"}`}
          >
            <div className="flex items-start gap-2">
              <Sparkles size={14} className="text-[var(--teal)] mt-0.5 shrink-0" />
              <div className="min-w-0">
                <p className="serif text-lg leading-tight text-[var(--coffee)]">{s.title}</p>
                <p className="text-sm text-[var(--coffee-medium)] mt-1 leading-snug">{s.body}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
